import React from 'react';

import styled from '@emotion/styled';

interface PageLayoutProps {
  children?: any;
}

// Every page's frame: a centred column with roomy, even gutters. The
// greeting lives on the Overview only (Mercury), not on every page.
const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default PageLayout;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 36px 40px;

  @media (max-width: 1100px) {
    padding: 28px 24px;
  }

  @media (max-width: 560px) {
    padding: 20px 16px;
  }
`;
